"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var DomainsList_1 = require("./component/DomainsList");
var DomainEditor_1 = require("./component/DomainEditor");
var PDomainsList = /** @class */ (function (_super) {
    __extends(PDomainsList, _super);
    function PDomainsList(props) {
        return _super.call(this, props) || this;
    }
    PDomainsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_ADT = this.props.listDomains.Subscribe("*", function (id, data) {
            _this.setState({ avail_domain_types: data.data });
        });
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.listAppCountries.Subscribe("*", function (id, data) {
            _this.setState({ avail_countries: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize,
                country_list: data.country_list,
                all_country: data.all_countries
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_countries: [],
            avail_domain_types: [],
            country_list: this.props.state.getCountriesList(),
            all_country: this.props.state.getIsAllCountries()
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.listAppCountries.LoadData();
            _this.props.listDomains.LoadData();
        });
    };
    PDomainsList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listAppCountries.UnSubscribe(this.SID_AC);
        this.props.listDomains.UnSubscribe(this.SID_ADT);
    };
    PDomainsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PDomainsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PDomainsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PDomainsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PDomainsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PDomainsList.prototype.onCountryFilterChanged = function (allCountries, CountryId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllCountries(allCountries, true);
        }
        if (Action === "add") {
            this.props.state.addCountry(CountryId, true);
        }
        if (Action === "remove") {
            this.props.state.delCountry(CountryId, true);
        }
    };
    PDomainsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(DomainEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands, availCountries: this.state.avail_countries, availDomainTypes: this.state.avail_domain_types }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(DomainEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands, availCountries: this.state.avail_countries, availDomainTypes: this.state.avail_domain_types }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(DomainsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onCountryFilterChanged: this.onCountryFilterChanged.bind(this), availCountries: this.state.avail_countries, countriesList: this.state.country_list, allCountries: this.state.all_country }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PDomainsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PDomainsList.getPageDescription = function (state) {
        return {
            icon: "atlas",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_main_brands_domains + "-id",
            itemTitle: "Домены",
            route: routes_1.routes.page_main_brands_domains,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PDomainsList;
}(React.Component));
exports.default = PDomainsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_domains_list/ui/PDomainsList.tsx
// module id = 2354
// module chunks = 0